import { classNames } from '@/utils/methods'
import { Heading } from '@saasalerts/ui'
import React, { FC } from 'react'
interface TitleProps {
  className?: string
}
export const Title: FC<React.PropsWithChildren<TitleProps>> = ({
  children,
  className = '',
}) => {
  return (
    <Heading type="h2" className={classNames('!text-brand-600', className)}>
      {children}
    </Heading>
  )
}
